import React, { FC, useMemo } from "react";
import { useDevice } from "@lookiero/aurora";
import { useI18n } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { Feature as FeatureReadModel } from "../../../../../../domain/entities/product/Features";
import { DOMAIN } from "../../../../i18n/i18n";
import { capitalizeFirstChar } from "../../../../shared/util/string";
import { shouldDisplayPercentages } from "./Features.controller";
import { style as featuresStyle } from "./Features.styles";

interface FeaturesProps {
  readonly features: FeatureReadModel[];
}

const Features: FC<FeaturesProps> = ({ features }) => {
  const { formatMessage } = useI18n({ domain: DOMAIN });
  const { screen } = useDevice();

  const style = useMemo(() => featuresStyle(), []);

  return (
    <>
      {features.map((item, index) => {
        const isLastItem = index === features.length - 1;

        if (item.featureValues.length === 0) {
          return;
        }

        return (
          <Text key={item.key} style={isLastItem ? undefined : style.itemMargin}>
            <Text level={screen.L ? 1 : 2} style={style.featureLabel}>
              {`${formatMessage({ id: item.key })}: `}
            </Text>

            <Text level={screen.L ? 1 : 2} style={style.featureValue} variant="detail">
              {item.featureValues.map((descriptionKeyItem, index) => {
                const { qualifierValues } = descriptionKeyItem.qualifier || {};
                const descriptionKey = formatMessage({ id: descriptionKeyItem.key });
                const itemConcat = index === item.featureValues.length - 1 ? "" : ". ";

                const qualifierValuesText = qualifierValues?.map(
                  (value) => `${formatMessage({ id: value.key })}% ${descriptionKey}${itemConcat}`,
                );

                return shouldDisplayPercentages(descriptionKeyItem.qualifier)
                  ? qualifierValuesText
                  : `${index === 0 ? capitalizeFirstChar(descriptionKey) : descriptionKey}${itemConcat}`;
              })}
            </Text>
          </Text>
        );
      })}
    </>
  );
};

export { Features };
